module.exports = {
      id: "icon-facebook-usage",
      viewBox: "0 0 13.521 25.459",
      url: "/" + "sprite-e509a544a5c47560e0a2aa1e13829d5a.svg#icon-facebook",
      toString: function () {
        return this.url;
      }
    }